import React, { useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

import HeaderRightTwo from "../Header-Right/HeaderRight-Two";
import Search from "../Offcanvas/Search";
import Category from "../Category/Category";

import logo from "../../../public/images/logo/elms-logo-black2.png";
import logo1 from "../../../public/images/logo/elms-logo-black2.png";
import { useUser } from "@/context/UserContext";
import HrNav from "../HrNav";
import { useAppContext } from "@/context/Context";

const HeaderHr = ({
  headerType,
  gapSpaceBetween,
  sticky,
  headerSticky,
  navigationEnd,
  container,
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [topBarHeight, setTopBarHeight] = useState(0);
  const { user } = useUser();

  const { isLightTheme } = useAppContext()

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };



    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      checkHeaderTopBarHeight(mobile);
    };

    const checkHeaderTopBarHeight = (mobile = false) => {
      if (!mobile) {
        const headerTopBar = document.querySelector('.rbt-header-top');
        if (headerTopBar) {
          const isVisible = window.getComputedStyle(headerTopBar).display !== 'none';
          setTopBarHeight(isVisible ? headerTopBar.offsetHeight : 0);
        } else {
          setTopBarHeight(0);
        }
      } else {
        setTopBarHeight(0);
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && !isMobile) {
          const headerTopBar = document.querySelector('.rbt-header-top');
          if (!headerTopBar) {
            setTopBarHeight(0);
          } else {
            checkHeaderTopBarHeight();
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    handleResize();
    checkHeaderTopBarHeight();

    const intervalId = setInterval(() => {
      if (!isMobile) {
        checkHeaderTopBarHeight();
      }
    }, 500);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
      observer.disconnect();
      clearInterval(intervalId);
    };
  }, [isMobile]);

  const headerStyle = {
    position: 'fixed',
    top: `${isMobile ? 0 : (topBarHeight > 0 ? topBarHeight - 0 : 0)}px`,
    left: '0',
    right: '0',
    zIndex: 998,
    width: '100%',
    transition: 'top 0.3s ease',
  };

  return (
    <>
      <div
        className={`rbt-header-wrapper ${gapSpaceBetween} ${sticky}  ${!headerType && isSticky ? `${headerSticky}` : ""
          }`}
        style={headerStyle}
      >
        <div className={`${container}`}>
          <div className={`mainbar-row ${navigationEnd} align-items-center`}>
            <div className="header-left rbt-header-content">
              <div className="header-info">
                <div className="logo">
                  <Link href="/">
                    {isLightTheme ? <Image
                      src={logo}
                      width={152}
                      height={50}
                      alt="Edu-cause"
                    /> : <Image
                      src={logo1}
                      width={152}
                      height={50}
                      alt="Edu-cause"
                    />}
                  </Link>
                </div>
              </div>

              <div className="header-info d-none d-lg-block">
                <Category />
              </div>
            </div>
            <div className="rbt-main-navigation d-none d-xl-block">
              <HrNav />
            </div>
            <HeaderRightTwo
              userType={user?.firstName ? user?.firstName : user?.userName ? user?.userName : user?.companyName ? user?.companyName : "Guest"}
              btnText="Enroll Now"
              btnClass="rbt-marquee-btn marquee-auto btn-border-gradient radius-round btn-sm hover-transform-none"
            />
          </div>
        </div>
        <Search />
      </div>
    </>
  );
};

export default HeaderHr;
